<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 5 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Cuestiones técnicas</h2>

      <h3 class="font-bold text-[18px] pb-6">Datos de entrenamiento</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="aiSystemUpdate"
            classes="min-w-full">
            <desy-label>Frecuencia y política de actualización*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay política de actualización
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'aiSystemUpdate', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="aiSystemUpdateRequired()">
        <div class="flex flex-col -mt-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="aiSystemUpdateDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la política de actualización del sistema de IA'"
            formControlName="aiSystemUpdateDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'aiSystemUpdateDescription', formSubmitted()) as error;
              else aiSystemUpdateDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #aiSystemUpdateDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <h3 class="font-bold text-[18px] pb-6 mt-6">Operación</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="latencyPerformance"
            classes="min-w-full">
            <desy-label>Latencia y rendimiento verificados*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay latencia y rendimiento verificados
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'latencyPerformance', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="latencyPerformanceRequired()">
        <div class="flex flex-col -mt-4 mb-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="latencyPerformanceDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la latencia y el rendimiento verificados del sistema de IA'"
            formControlName="latencyPerformanceDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'latencyPerformanceDescription', formSubmitted()) as error;
              else latencyPerformanceDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #latencyPerformanceDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2 items-end">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="scalability"
            classes="min-w-full">
            <desy-label>Escalabilidad documentada*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay escalabilidad documentada
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'scalability', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <ng-container *ngIf="scalabilityRequired()">
            <label class="text-[14px] text-neutral-dark block">CSV*</label>
            <desy-input
              id="scalabilityCsv"
              [classes]="'w-full'"
              [placeholder]="'Objeto 1, Objeto 2...'"
              formControlName="scalabilityCsv"></desy-input>
            <desy-error-message *ngIf="getError(form, 'scalabilityCsv', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </ng-container>
        </div>
      </div>

      <div class="grid grid-cols-2 items-end">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="contingencyPlan"
            classes="min-w-full">
            <desy-label>Plan de contingencia y desactivación*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay plan de contingencia
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'contingencyPlan', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <ng-container *ngIf="contingencyPlanRequired()">
            <label class="text-[14px] text-neutral-dark block">CSV*</label>
            <desy-input
              id="contingencyPlanCsv"
              [classes]="'w-full'"
              [placeholder]="'Objeto 1, Objeto 2...'"
              formControlName="contingencyPlanCsv"></desy-input>
            <desy-error-message *ngIf="getError(form, 'contingencyPlanCsv', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </ng-container>
        </div>
      </div>

      <h3 class="font-bold text-[18px] pb-4 mt-6">Seguridad</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="cybersecurity"
            classes="min-w-full">
            <desy-label>Ciberseguridad integrada*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay ciberseguridad integrada
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'cybersecurity', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!cybersecurityExtraFilled() && cybersecurityRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="cybersecurityRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Con CSV</span>
            <desy-input
              id="cybersecurityCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="cybersecurityCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark block">Descripción</span>
          <desy-textarea
            id="cybersecurityDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="cybersecurityDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="accessControl"
            classes="min-w-full">
            <desy-label>Control de acceso y autenticación*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay control de acceso y autenticación
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'accessControl', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="accessControlRequired()">
        <div class="flex flex-col -mt-4 mb-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="accessControlDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí el control de acceso y autenticación del sistema de IA'"
            formControlName="accessControlDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'accessControlDescription', formSubmitted()) as error;
              else accessControlDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #accessControlDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="attackProtection"
            classes="min-w-full">
            <desy-label>Protección contra ataques adversariales*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay protección contra ataques adversariales
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'attackProtection', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!attackProtectionExtraFilled() && attackProtectionRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="attackProtectionRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Con CSV</span>
            <desy-input
              id="attackProtectionCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="attackProtectionCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark block">Descripción</span>
          <desy-textarea
            id="attackProtectionDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="attackProtectionDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="resilience"
            classes="min-w-full">
            <desy-label>Resiliencia frente a fallos*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona sI hay resiliencia frente a fallos
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'resilience', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!resilienceExtraFilled() && resilienceRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="resilienceRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Con CSV</span>
            <desy-input
              id="resilienceCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="resilienceCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark block">Descripción</span>
          <desy-textarea
            id="resilienceDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="resilienceDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>
    </div>
  </div>
</form>
